<template>
    <div class="myskov-login">
        <div class="myskov-login__col">
            <div class="login-fields">
                <h2 v-text="translations.title"></h2>
                <p v-text="translations.sub_title"></p>
                <template v-if="!success">
                    <div class="input-fields">
                        <input-field :name="translations.input_email" :value="email" @input="(val) => email = val" input-type="email" @enter="sendPwReset" class="booking-field"></input-field>
                        <msg-block type="error" v-if="showErrors && isNotValid && isNotValid.email">
                            <p v-for="error in isNotValid.email"><b v-text="error"></b></p>
                        </msg-block>
                    </div>
                    <button class="btn" @click="sendPwReset" v-text="translations.send_pw_reset_btn" :class="{'item-loading': loading}" :disabled="loading"></button>
                    <msg-block type="error" v-if="resetError">
                        <p><b v-text="resetError"></b></p>
                    </msg-block>
                </template>
                <msg-block v-if="success">
                    <p><b v-text="translations.reset_success"></b></p>
                </msg-block>
            </div>
        </div>
        <div class="myskov-login__col">
            <div class="login-help">
                <h2 v-text="translations.help_txt_title">Det er kedeligt at glemme sin adgangskode.</h2>
                <p v-for="text in translations.help_txt" v-html="text"></p>
            </div>
        </div>
    </div>
</template>

<script>
import InputField from '../input-field.vue';
import Validate from 'validate.js';
import MsgBlock from '../msg-block.vue';
import SkovApi from '../../skovapi.js';

export default {
    data() {
        return {
            showErrors: false,
            resetError: null,
            success: false,
            translations: APP_CONFIG.TRANSLATION.FORGOT_PW,
            loading: false,
            email: ''
        }
    },
    methods: {
        sendPwReset() {
            this.resetError = null;
            if(this.isNotValid) {
                this.showErrors = true;
                return;
            }

            if(this.loading)
                return;

            this.loading = true;
            this.showErrors = false;

            SkovApi.passwordReset(this.email).then((res) => {
                this.success = true;
            }).catch((error) => {
                console.error(error);
                this.resetError = this.translations.ERRORS.reset_failed;
            });
        }
    },
    computed: {
        isNotValid() {
            let errors = Validate({email: this.email}, {
                email: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.email  
                    },
                    email: {
                        message: this.translations.ERRORS.not_valid_email
                    }
                }
            }, {
                fullMessages: false
            });

            return (errors) ? errors : null;
        }
    },
    components: {
        InputField,
        MsgBlock
    }
}
</script>
